import React, { MouseEventHandler } from 'react';
import CloseIcon from '../icons/CloseIcon';
import './CloseButton.scss';

export interface ICloseButtonProps {
  className?: string;
  onClick: () => void;
}

export const CloseButton: React.FC<ICloseButtonProps> = ({ className, onClick }) => {
  let buttonClasses = 'close-button-component';
  if (className) {
    buttonClasses = `${buttonClasses} ${className}`;
  }
  const clickHandler: MouseEventHandler<HTMLSpanElement> = (e) => {
    e.preventDefault();
    onClick();
  };
  return (
    <span className={buttonClasses} onClick={clickHandler}>
      <CloseIcon width={15} height={15} />
    </span>
  );
};
export default CloseButton;
